function isCurrentBankBalance(item) {
  return String(item?.label || '').trim().toLowerCase() === 'current bank balance';
}

/** Number rows from 1. Current Bank Balance keeps id 0 when it is already 0. */
function renumberCashSequences(items) {
  const rows = items || [];
  let next = 1;
  for (const item of rows) {
    if (isCurrentBankBalance(item) && Number(item.sequence) === 0) {
      item.sequence = 0;
      continue;
    }
    item.sequence = next;
    next += 1;
  }
  return rows;
}

function nextCashItemSequence(items) {
  let max = 0;
  for (const item of items || []) {
    const sequence = Number(item?.sequence);
    if (Number.isFinite(sequence) && sequence > max) max = sequence;
  }
  return max + 1;
}

function applyCashSequenceEdit(items, index, newSequence) {
  const next = (items || []).map((item) => ({ ...item }));
  if (!next[index]) return next;
  next[index].sequence = parseFloat(newSequence);
  next.sort((a, b) => a.sequence - b.sequence);
  return renumberCashSequences(next);
}

/** Three later weeks of this row, numbered N.1 N.2 N.3 so a sort puts them underneath. */
function weeklyCashItemCopies(item) {
  const day = parseInt(String(item?.date ?? '').replace(/\D/g, ''), 10);
  if (!Number.isInteger(day) || day < 1 || day > 31) return [];
  const base = Number(item?.sequence);
  const start = Number.isFinite(base) ? base : 0;
  const copies = [];
  for (let step = 1; step <= 3; step += 1) {
    const nextDay = day + step * 7;
    if (nextDay > 31) break;
    copies.push({
      ...item,
      date: String(nextDay).padStart(2, '0'),
      weekly: false,
      sequence: Number((start + step / 10).toFixed(1)),
    });
  }
  return copies;
}

module.exports = {
  renumberCashSequences,
  nextCashItemSequence,
  applyCashSequenceEdit,
  weeklyCashItemCopies,
};
